<template>
  <div v-loading="loading" class="checked-list">
    <span class="checked-list__title" v-if="!hiddenTitle" :style="{ width: labelWidth }">{{ title }}</span>
    <div class="checked-list__body">
      <iv-button
        class="checked-item"
        v-if="hasCleanButton"
        @click="clear()"
        :type="checkedList.length <= 0 ? 'primary' : 'text'"
        size="small"
      >不限</iv-button><iv-button
        class="checked-item"
        v-for="option in options"
        :key="option.id"
        :type="option.checked ? 'primary' : 'text'"
        size="small"
        @click="onChecked(option)"
      >{{ option.title }}</iv-button>
    </div>
  </div>
</template>
<script>
import { checker } from "@/utils/"
export default {
  name: 'CheckedList',
  model: {
    prop: 'checked',
    event: 'changed'
  },
  props: {
    title: {
      type: String,
      default: "选项："
    },
    hiddenTitle: {
      type: Boolean,
      default: false
    },
    labelWidth: {
      type: String,
      default: 'auto'
    },
    sources: {
      type: Array,
      default(){
        return []
      }
    },
    checked: {
        type: Array,
        default:() =>  []
    },
    maximun: {
        type: Number,
        default: NaN
    },
    hasCleanButton: {
      type: Boolean,
      default: true
    },
    loading: Boolean
  },
  beforeCreate () {
    this.$_checker = checker()
  },
  data() {
    return{
      options: this.initResources(this.sources)
    }
  },
  methods:{
    onChecked(item, e){
      if(this.checkOne) {
          this.$_checker.clear()
      }
      this.$_checker.checked(item.id, !item.checked)
      this.changedResources()
      this.$nextTick(()=>this.$emit('changed', this.$_checker.checkedList))
    },
    initResources(val=this.sources, clear=true){
      return this.options = val.map(item=>{
        if(typeof item.id === 'undefined') throw new Error('选项必须有id!')
        if(typeof item.disabled == 'undefined') item.disabled = false
        if(typeof item.checked == 'undefined') item.checked = false
        return item
      })
    },
    changedResources(val=this.sources){
      if(!(val && val.constructor === Array)) return []
      return this.options = val.map(item=>{
        const disabled = this.$disabled(item)
        const checked = this.checkedList.indexOf(item.id)>-1
        if(!checked){
            item.disabled = disabled
        }
        if(item.checked!==checked) item.checked = checked
        return item
      })

    },
    $disabled(item){
        if(this.checkOne || this.checkedList.length <= 0) return false
        return !this.checkedList.find(option=>item.id==option) && this.isMax()
    },
    isMax(){
        if(this.maximun <= 0 || Number.isNaN(this.maximun)) return false
        return this.checkedList.length >= this.maximun
    },
    clear(){
      this.$_checker.clear()
      this.changedResources()
      this.$nextTick(()=>this.$emit('changed', this.$_checker.checkedList))
    }
  },
  watch: {
    sources(val){
      this.initResources(val)
      this.changedResources(val)
    },
    checked(val){
      if(val.constructor != Array) return
      val.forEach(item=>this.$_checker.checked(item))
      this.changedResources()
    }
  },
  computed:{
      checkedList: {
          get(){
              return this.$_checker.checkedList;
          }
      },
      checkOne(){
          return this.maximun === 1;
      }
  },
}
</script>
<style lang="scss" scoped>
.checked-list{
  position: relative;
  margin-bottom: 15px;
  @media screen and (min-width: 768px) {
    display: flex;
  }
  &__title{
    flex-shrink: 0;
    margin-right: 5px;
    margin-bottom: 10px;
    display: block;
    @media screen and (min-width: 768px) {
      text-align: right;
    }
  }
  &__body{
    flex-grow: 1;
    > * {
      margin-bottom: 5px;
    }
  }
}
.checked-item{
  margin-right: 5px;
}
</style>
